
import { Row } from 'antd'
import _ from 'lodash'
import React, { useEffect, useState } from 'react'
const RaffleListDisplay = props => {
  const [raffleTickets, setRaffleTickets] = useState('')

  useEffect(() => {
    let ticketString = ''

    props?.participants?.map(participant => {
      _.times(participant.stats.standard.wins + participant.stats.honor + 1, () => {
        ticketString += `${_.capitalize(participant.first_name)} ${_.capitalize(participant.last_name)} \n`
      })
      return Object.assign({}, participant, { tickets: participant.stats.standard.wins + participant.stats.honor + 1 })
    })

    setRaffleTickets(ticketString)
  }, [props.participants])

  return (
    <>
      <Row style={{ marginTop: '2em' }}>
        <textarea style={{ width: '100%', height: '200px' }} value={raffleTickets} />
      </Row>
    </>
  )
}

export default RaffleListDisplay
